import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialState: Dtos.Trial & IRegistrationFormState = {
    id: null,
    protocolID: null,
    newProposalNumber: null,
    trialDevelopmentNumber: null,
    allIdentifiers: null,
    studyAcronym: null,
    title: null,
    shortTitle: null,
    trialChair1PersonnelId: null,
    trialChair1Personnel: null,
    trialChair2PersonnelId: null,
    trialChair2Personnel: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    trialItems: [],
    trialGroups: [],
    trialInstitutions: [],
    trialItemCategories: [],
    globalRoleSummaries: [],
    display: null,
    notes: [],
    comments: null,
    confidentialityDeedRequired: null,
    institutionCodingId: null,
    institutionCoding: null,
    trialTypeId: null,
    trialType: null,
    trialStatusId: null,
    trialStatus: null,
    dateActivated: null,
    dateFirstPatient: null,
    dateAccrualComplete: null,
    dateStudyClosed: null,
    dateCompletedWithdrawn: null,
    internationalTrialStatusId: null,
    internationalTrialStatus: null,
    internationalDateActivated: null,
    internationalDateAccrualCompleted: null,
    initialsCrfItemName: null,
    targetAccrual: null,
    totalAccrual: null,
    targetDateAccrualCompleted: null,
    targetDateFollowupCompletion: null,
    internationalTargetAccrual: null,
    internationalTotalAccrual: null,
    internationalTargetDateAccrualCompleted: null,
    internationalTargetDateFollowupCompletion: null,
    apiKey: null,
    registrationWebsite: null,
    openClinciaProtocolID: null,
    openClinciaInstitutionPrefix: null,
    patientDetailsCRF: null,
    treatmentCrfItemName: null,
    australianLeadGroup: null,
    internationalLeadGroup: null,
    personnelCount: null,
    isLegacyUserDatabase: null,
    shortDisplay: null,
    displayName: null,
    sendReminderEmail: null,
    sendReminderAfterDays: null,
    sendReminderStandardEmailTemplateId: null,
    sendReminderStandardEmailTemplate: null,
    projectProtocolID: null,
    projectScientificTitle: null,
    projectShortTitle: null,
    projectAckSource: null,
    projectTrialDeveloperId: null,
    projectDateSubmitted: null,
    projectOutcomeId: null,
    substudyOfTrial: false, 
    substudyId: null,  
    recruitmentTimeline: null, 
    trialCoordination: null, 
    specialNote: null, 
    publicationAcknowledgments: null,
    substudy: null,
    viewCode: null,
    personnel: null
}

export interface ITrialReduxFormState {
    id: IFieldState<number>,
    protocolID: IFieldState<string>,
    newProposalNumber: IFieldState<string>,
    trialDevelopmentNumber: IFieldState<string>,
    allIdentifiers: IFieldState<string>,
    studyAcronym: IFieldState<string>,
    title: IFieldState<number>,
    shortTitle: IFieldState<string>,
    trialChair1PersonnelId: IFieldState<number>,
    trialChair1Personnel: IFieldState<Dtos.Personnel>,
    trialChair2PersonnelId: IFieldState<number>,
    trialChair2Personnel: IFieldState<Dtos.Personnel>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    trialItems: IFieldState<Dtos.TrialItem[]>,
    trialGroups: IFieldState<Dtos.TrialGroup[]>,
    trialInstitutions: IFieldState<Dtos.TrialInstitution[]>,
    trialItemCategories: IFieldState<Dtos.TrialItemCategory[]>,
    globalRoleSummaries: IFieldState<Dtos.PersonnelRoleSummary[]>,
    notes: IFieldState<Dtos.NoteTypeNotes[]>,
    comments: IFieldState<string>,
    confidentialityDeedRequired: IFieldState<boolean>,
    institutionCodingId: IFieldState<number>,
    institutionCoding: IFieldState<Dtos.InstitutionCoding>,
    trialTypeId: IFieldState<number>,
    trialType: IFieldState<Dtos.TrialType>,

    trialStatusId: IFieldState<number>,
    trialStatus: IFieldState<Dtos.TrialStatus>,
    dateActivated: IFieldState<string>,
    dateFirstPatient: IFieldState<string>,
    dateAccrualComplete: IFieldState<string>,
    dateStudyClosed: IFieldState<string>,
    dateCompletedWithdrawn: IFieldState<string>,

    internationalTrialStatusId: IFieldState<number>,
    internationalTrialStatus: IFieldState<Dtos.InternationalTrialStatus>,
    internationalDateActivated: IFieldState<string>,
    internationalDateAccrualCompleted: IFieldState<string>,


    targetAccrual: IFieldState<number>,
    totalAccrual: IFieldState<number>,
    targetDateAccrualCompleted: IFieldState<string>,
    targetDateFollowupCompletion: IFieldState<string>,
    internationalTargetAccrual: IFieldState<number>,
    internationalTotalAccrual: IFieldState<number>,
    internationalTargetDateAccrualCompleted: IFieldState<string>,
    internationalTargetDateFollowupCompletion: IFieldState<string>,
    apiKey: IFieldState<string>,
    registrationWebsite: IFieldState<string>,
    australianLeadGroup: IFieldState<string>,
    internationalLeadGroup: IFieldState<string>,
    personnelCount: IFieldState<number>,
    patientDetailsCRF: IFieldState<string>,
    treatmentCrfItemName: IFieldState<string>,
    isLegacyUserDatabase: IFieldState<boolean>,
    sendReminderEmail: IFieldState<boolean>,
    sendReminderAfterDays: IFieldState<number>,
    sendReminderStandardEmailTemplateId: IFieldState<number>,

    projectProtocolID: IFieldState<string>;
    projectScientificTitle: IFieldState<string>;
    projectShortTitle: IFieldState<string>;
    projectAckSource: IFieldState<string>;
    projectTrialDeveloperId: IFieldState<number>;
    projectDateSubmitted: IFieldState<string>;
    projectOutcomeId: IFieldState<number>;

    substudyOfTrial: IFieldState<boolean>, 
    substudyId: IFieldState<number>,  
    recruitmentTimeline: IFieldState<string>, 
    trialCoordination: IFieldState<string>, 
    specialNote: IFieldState<string>, 
    publicationAcknowledgments: IFieldState<string>
}
